import {translateFunction} from "../../../../localization/TranslationService";
import {pageAuthorizedByGroup} from "../../../fragments/PageAuthorization";
import {Box, Breadcrumbs, Button, CircularProgress, InputLabel, MenuItem, Select, Stack} from "@mui/material";
import React, {useState} from "react";
import {useQuery} from "@apollo/client";
import {GET_ALL_CUSTOM_ATTRIBUTES_SETUP, SUPPLIER_INDEX} from "../../Queries";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {productsEditorDefaultTargetStage, productsEditorTargetStage} from "../../ProductModuleOverview";
import {CustomAttributeSetup} from "../../models/CustomAttributeSetup";
import {Link} from "react-router-dom";
import {ProductSupplier} from "../../models/ProductSupplier";
import {HeaderSlot, StageSwitch} from "../../../../components/onsite/Footer";
import {CustomAttributeBulkEditorSuppliers} from "./CustomAttributeBulkEditorSuppliers";

const translate = translateFunction("SureBasePortalProductsCatalog");
export const CustomAttributeBulkEditorSuppliersWizard = pageAuthorizedByGroup(function () {
	const [customAttributes, setCustomAttributes] = useState<CustomAttributeSetup[]>();
	const [selectCustomAttributes, setSelectCustomAttributes] = useState<CustomAttributeSetup[]>();
	const [selectedCustomAttributeIds, setSelectedCustomAttributeIds] = useState<string[]>([]);
	const [selectedProductSupplierKrns, setSelectedProductSupplierKrns] = useState<string[]>([]);
	
	const [productSuppliers, setProductSuppliers] = useState<ProductSupplier[]>();
	const [selectedProductSuppliers, setSelectedProductSuppliers] = useState<ProductSupplier[]>();
	
	const [proceed, setProceed] = useState(false);
	const supplierIndex = useQuery(SUPPLIER_INDEX, {
		client: graphQLServices.productsClient,
		fetchPolicy: "no-cache",
		variables: {
			stage: productsEditorTargetStage,
		}
	});
	
	const {loading, data, error} = useQuery(GET_ALL_CUSTOM_ATTRIBUTES_SETUP, {
		client: graphQLServices.productsClient,
		fetchPolicy: "no-cache",
		variables: {
			stage: productsEditorTargetStage,
		}
	});
	
	if (supplierIndex.loading || loading)
		return <Box sx={{display: "flex", width: "100%", height: "100%"}}>
			<CircularProgress style={{margin: "auto"}}/>
		</Box>;

	if (error)
		throw error;

	const attributeNodes = data.customAttributeSetup.nodes;
	if (attributeNodes === null || attributeNodes?.length === 0)
		throw new Error(`CustomAttributeSetups not found.`);
	
	if (!customAttributes) {
		setCustomAttributes(attributeNodes);
	}
	
	if (!productSuppliers) {
		supplierIndex.data.productSuppliers.nodes.sort((a:ProductSupplier, b:ProductSupplier) => a.legalName!.toLowerCase().localeCompare(b.legalName!.toLowerCase()));
		setProductSuppliers(supplierIndex.data.productSuppliers.nodes);
		
	}
	
	if (!selectCustomAttributes) {
		setSelectCustomAttributes(attributeNodes);
	}
	
	function openProductBulkEditor() {
		if (!customAttributes || !productSuppliers)
			return;
		const attributes = [];
		const attributeLookup = new Set<string>(selectedCustomAttributeIds);
		for (const item of customAttributes) {
			if (attributeLookup.has(item.id))
				attributes.push(item);
		}
		
		const suppliers:ProductSupplier[] = [];
		const supplierLookup = new Set<string>(selectedProductSupplierKrns);
		for (const item of productSuppliers) {
			if (supplierLookup.has(item.krn))
				suppliers.push(item);
		}
	
		setSelectedProductSuppliers(suppliers);
		setSelectCustomAttributes(attributes);
		setProceed(true);
	}
	
	return (
		<>
			<Breadcrumbs style={{margin: "5px"}}>
				<Link style={{color: "inherit", textDecoration: "unset"}} to="/products">{translate("Products")}</Link>
				<Link style={{color: "inherit", textDecoration: "unset"}} to="/products/custom_attribute_bulk">{translate("Custom attribute bulk editor options")}</Link>
			</Breadcrumbs>
			{!proceed &&
				<Stack gap={1} alignContent={"start"} style={{maxWidth: "700px"}}>
					<HeaderSlot><StageSwitch defaultTargetStage={productsEditorDefaultTargetStage}/></HeaderSlot>
					<Stack>
						<InputLabel id={"custom-attributes"}>{translate("Custom attributes")}</InputLabel>
						<Select
							labelId={"custom-attributes"}
							label={translate("Custom attributes")}
							variant={"standard"}
							multiple={true}
							value={selectedCustomAttributeIds}
							onChange={event => setSelectedCustomAttributeIds(event.target.value as string[])}
						>
							<MenuItem key={"null"} value={""} hidden={true} style={{display: "none"}}></MenuItem>
							{selectCustomAttributes?.map(it =>
								<MenuItem key={it.id} value={it.id}>{it.description} - {it.mapping}</MenuItem>)}
						</Select>
					</Stack>
					<Stack>
						<InputLabel id={"suppliers-select"}>{translate("Product suppliers")}</InputLabel>
						<Select
							labelId={"suppliers-select"}
							label={translate("Suppliers")}
							variant={"standard"}
							multiple={true}
							value={selectedProductSupplierKrns}
							onChange={event => setSelectedProductSupplierKrns(event.target.value as string[])}
						>
							<MenuItem key={"null"} value={""} hidden={true} style={{display: "none"}}></MenuItem>
							{productSuppliers?.map(it =>
								<MenuItem key={it.krn} value={it.krn}>{it.legalName + "  -   " + it.krn}</MenuItem>)}
						</Select>
					
					</Stack>
					<Button disabled={selectedCustomAttributeIds.length === 0 || selectedProductSupplierKrns.length === 0} onClick={openProductBulkEditor} color={"success"}>{translate("Edit suppliers")}</Button>
				</Stack>
			}
			
			{proceed &&
				<CustomAttributeBulkEditorSuppliers customAttributes={selectCustomAttributes || []} suppliers={selectedProductSuppliers || []}/>
			}
		</>
	);
}, ["Admin", "Product"]);

